import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite, TweenLite} from "gsap";
import {PearlHarbor} from "../../PearlHarbor";

export class PearlHarborFSIntroPresentation implements FlowStatePresentation {
    private _flowStateController: FlowStateController;

    constructor() {
    }

    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;

        if (PearlHarbor.autoPlayPlugin.turnOffAutoplayOnBonus) {
            PearlHarbor.autoPlayPlugin.turnOffAutoplayOnBonus();
        }
        const tl: TimelineLite = PearlHarbor.fsIntroView.show((index: number) => this.complete(index), PearlHarbor.apiPlugin.isReplay);

    }

    public shouldRun(): boolean {
        const isRestore: boolean = PearlHarbor.model.isRestore,
            isFS:boolean = !PearlHarbor.model.isNextNormal,
            freespinTriggeredThisSpin:boolean = PearlHarbor.model.data.freespinTriggeredThisSpin;
        return (isRestore && isFS) || freespinTriggeredThisSpin;
    }

    public complete(index: number):void {
        this._flowStateController.finish();

        PearlHarbor.cocpitBoard.show(PearlHarbor.model.isRestore);
        PearlHarbor.setMode(PearlHarbor.model.data.nextMode);
        PearlHarbor.mainGameZoomContainer.hideOnFSIntro();
        PearlHarbor.activeSymbolsBackground.hideOnFSIntro();
    }
}